export default __webpack_public_path__ + "static/media/instr03.0acbfbd4.svg";